module.exports = __webpack_public_path__ + "img/logo_valevistasntdr.6625f564.png";